import isCacheEmpty from 'owa-recipient-cache/lib/utils/isCacheEmpty';
import { FindRecipientInfoType } from 'owa-recipient-common/lib/components/FindRecipientInfo';
import { isStringNullOrWhiteSpace } from 'owa-strings';
import isValidEmailAddress from 'owa-readwrite-recipient-well/lib/utils/isValidEmailAddress';
export default function shouldShowHeaderFooterItem(infoType, viewState) {
    return function () {
        switch (infoType) {
            case FindRecipientInfoType.Searching:
                return hasQueryString(viewState) && viewState.isSearching;
            case FindRecipientInfoType.TypeToSearch:
                return hasQueryString(viewState) && isCacheEmpty();
            case FindRecipientInfoType.SearchDirectory:
                return (hasQueryString(viewState) &&
                    !viewState.isSearching &&
                    !viewState.hasSearchedDirectory);
            case FindRecipientInfoType.TopNResults:
                return hasQueryString(viewState) && viewState.hasSearchedDirectory;
            case FindRecipientInfoType.UseAddress:
                return (hasQueryString(viewState) &&
                    viewState.hasSearchedDirectory &&
                    viewState.findResultSet.length == 0 &&
                    isValidEmailAddress(viewState.queryString));
            case FindRecipientInfoType.SuggestedContacts:
                return !hasQueryString(viewState) && viewState.findResultSet.length >= 0;
            default:
                return false;
        }
    };
}
var hasQueryString = function (viewState) {
    return !isStringNullOrWhiteSpace(viewState.queryString);
};
//# sourceMappingURL=shouldShowHeaderFooterItem.js.map